<template>
	<div class="case-slideshow" v-if="slidesData">
		<div class="case-slideshow__slides" :style="'transform: translateX(-'+ currentSlideIndex*100 +'%)'">
			<template v-for="(slide, i) in slidesData" v-bind:key="i">

					<template v-if="slide.nsAlias === 'caseSlideshowImage'">
						<div v-if="slide.image" class="case-slideshow__slide">
							<!--<img :src="imageUrl(slide.image)"/>-->
							<PreloadedImage :src="imageUrl(slide.image)"/>
						</div>
					</template>

					<template v-if="slide.nsAlias === 'caseSlideshowVideo'">
						<div v-if="slide.videoImage" class="case-slideshow__slide case-slideshow__slide--video" @click="$emit('selectVideo', slide)">
							<img :src="imageUrl(slide.videoImage)"/>
						</div>
					</template>

			</template>
		</div>
		<div v-if="slidesData.length > 1" class="case-slideshow__controls">
			<div class="pagination">
				<div class="pagination__left-btn" @click="prevSlide"></div>
				<div class="pagination__count">
					<div class="pagination-number">
                        <span class="pagination-number__current">{{currentSlideIndex+1}}</span>
                        <span class="pagination-number__divider">I</span>
                        <span class="pagination-number__total">{{this.slidesData.length}}</span>
                    </div>
				</div>
				<div class="pagination__right-btn"  @click="nextSlide"></div>
			</div>
		</div>
	</div>
</template>

<script>
import config from '@/config.js';
import PreloadedImage from '@/components/PreloadedImage'

export default {
	name: 'CaseSlideshow',
	props: {
		slidesData: Array
	},
	components: {
		PreloadedImage
	},
	data()
	{
		return {
			currentSlideIndex: 0
		}
	},
	methods:
	{
		imageUrl(image)
		{
			var url = config.umbracoMediaPath + image.src;
			return url;
		},
		prevSlide()
		{
			if (this.currentSlideIndex > 0)
			{
				this.currentSlideIndex--;
			}
		},
		nextSlide()
		{
			if (this.currentSlideIndex+1 < this.slidesData.length)
			{
				this.currentSlideIndex++;
			}
		}
	}
}
</script>